import React from "react";
import HasOptionList from "./HasOptionList";
import Commons from "oc-commons/Commons";

/**
 *    <Select label={I18N("Welche Form soll Ihr Schrank haben?")}
 value={APP.arrangement.form}
 options={[
                        {value: "gerade", label: I18N("gerader Schrank")},
                        {value: "eckeLinks", label: I18N("Eckschrank links")},
                        {value: "eckeRechts", label: I18N("Eckschrank rechts")},
                        {value: "uform", label: I18N("uForm")},
                    ]}
 onChange={value => APP.arrangement.form=value} />
 */
export default class Select extends HasOptionList {

    static defaultProps = {
        id: undefined,
        name: undefined,
        value: undefined,
        label: undefined,
        disabled: false,
        hideIfNoOptions: false,
        disableIfSingleOption: false,
        hideIfSingleOption: false,
        onChange: undefined,
        getLabel: undefined,
        getValue: undefined,
        getUnknownValueLabel: undefined
    };

    ref = React.createRef();

    classNameSelect() {
        return "form-control";
    }

    extensionPointSpan() {
        return null
    }

    render() {
        const props = this.props;
        const options = this.getOptions();
        if (!_.isArray(options)) {
            debugger;
            return null;
        }
        const selectedOptionIndex = options.findIndex(o => this.isSameValue(this.getValue(o), props.value));

        if (props.hideIfNoOptions && options.length == 0 || props.hideIfSingleOption && options.length < 2) {
            return null;
        }

        return (
            <div className={this.classNameGroup() + ' ' + this.props.className}>
                {props.label && <label htmlFor={props.name}>{props.label}</label>}

                <select
                    className={this.classNameSelect()}
                    id={props.id}
                    name={props.name}
                    ref={this.ref}
                    value={selectedOptionIndex}
                    onChange={event => {
                        const i = this.ref.current.selectedIndex;
                        let option = i == -1 ? null : options[i];
                        this.onChange(option,event);
                    }}
                    disabled={props.disabled || (props.disableIfSingleOption && options.length < 2)} >
                    {options.map((option, index) => (
                        <option key={index} value={index}>{this.getLabel(option)}</option>
                    ))}
                    {(selectedOptionIndex==-1) && (
                        <option key={-1} value={-1}>{this.getUnknownValueLabel(props.value)}</option>
                    )}

                </select>
                {this.extensionPointSpan()}
            </div>
        );
    }
}
